const rewardsInfoStatus = ['active'];
const rewardsPendingStatus = ['pending', 'activation_failed'];

export const showRewardsModule = (userStatus, error, loading) => {
  if (error || loading) {
    return false;
  }

  const rewardStatus = userStatus?.getUserReward?.status;

  const showModule =
    rewardsInfoStatus.includes(rewardStatus) ||
    rewardsPendingStatus.includes(rewardStatus);

  return showModule;
};
